import './HoopsViewer.css';
import { jsxs as b, jsx as i, Fragment as G } from "react/jsx-runtime";
import C from "clsx";
import { forwardRef as J, useRef as g, useEffect as u, useState as H, useMemo as L } from "react";
import { useWebViewer as K } from "./HoopsViewer.hooks.mjs";
import { handleModelStructureReady as O, handleMeasurementValueSet as Q, handleModelLoadFailure as X } from "./HoopsViewer.utils.mjs";
import { HoopsViewerInnerContext as Y } from "./HoopsViewerContext.mjs";
import { useBundle as Z } from "./HoopsViewerContext.hooks.mjs";
import { H as $ } from "./HoopsViewerDimensions-B3ECFNLG.js";
import { H as ee } from "./HoopsViewerName-DV6WCWJa.js";
import { H as re } from "./HoopsViewerToolbar-DLrXfwTT.js";
const ne = "_wrapper_1g47u_1", oe = "_container_1g47u_6", V = {
  wrapper: ne,
  container: oe
}, te = (a, h) => {
  const n = g(a);
  u(() => {
    n.current = a;
  }, [a]);
  const x = g(String(Math.random())), [r, N] = H(null), [c, l] = H(!1), {
    loader: S,
    className: d,
    containerProps: R,
    containerClassName: m,
    children: y,
    originalFilename: z,
    url: f,
    dimensions: E,
    translationsPrefix: F,
    wrapperProps: _,
    nameElement: p,
    dimensionsElement: w,
    toolbarElement: v
  } = a, o = Z(), M = L(() => ({ endpointUri: f }), [f]), { viewer: t, API: e } = K(o, M, r);
  u(() => {
    if (!t || !o || !e)
      return;
    l(!1), typeof n.current.onLoading == "function" && n.current.onLoading();
    const s = O({
      viewer: t,
      API: e,
      bundle: o,
      cb: () => {
        typeof n.current.onLoaded == "function" && n.current.onLoaded(e), l(!0);
      }
    }), A = Q(), D = X({
      cb: (T, U, q) => {
        typeof n.current.onLoadFailure == "function" && n.current.onLoadFailure(e, { modelName: T, reason: U, error: q }), l(!1);
      }
    });
    return t.setCallbacks({
      modelStructureReady: s,
      modelLoadFailure: D,
      measurementValueSet: A
    }), t.start(), () => {
      t.shutdown();
    };
  }, [e, o, t]), u(() => {
    if (!r || !e)
      return;
    const s = () => {
      e.resizeCanvas();
    };
    r.addEventListener("resize", s), r && r.removeEventListener("resize", s);
  }, [e, r]);
  const P = C({
    [V.wrapper]: !0,
    [String(d)]: !!d
  }), B = C({
    [V.container]: !0,
    [String(m)]: !!m
  }), I = L(
    () => ({
      api: e,
      initialized: c,
      bundle: o,
      container: r
    }),
    [e, o, r, c]
  ), j = p === void 0 ? /* @__PURE__ */ i(ee, { name: z }) : p, k = w === void 0 ? /* @__PURE__ */ i($, { box: E }) : w, W = v === void 0 ? /* @__PURE__ */ i(re, { prefix: F }) : v;
  return /* @__PURE__ */ b("div", { ..._, ref: h, className: P, children: [
    /* @__PURE__ */ i("div", { ...R, ref: N, id: x.current, className: B }),
    /* @__PURE__ */ b(Y.Provider, { value: I, children: [
      j,
      k,
      W,
      y,
      c ? null : /* @__PURE__ */ i(G, { children: S })
    ] })
  ] });
}, we = J(te);
export {
  we as H
};
//# sourceMappingURL=HoopsViewer-BuflTFva.js.map
